export default __webpack_public_path__ + "static/media/Avenir.bd849aa4.ttc";